/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PractitionerSearchResponse } from './PractitionerSearchResponse';
import {
    PractitionerSearchResponseFromJSON,
    PractitionerSearchResponseFromJSONTyped,
    PractitionerSearchResponseToJSON,
    PractitionerSearchResponseToJSONTyped,
} from './PractitionerSearchResponse';

/**
 * 
 * @export
 * @interface SearchPractitioners200Response
 */
export interface SearchPractitioners200Response {
    /**
     * 
     */
    data: PractitionerSearchResponse;
}

/**
 * Check if a given object implements the SearchPractitioners200Response interface.
 */
export function instanceOfSearchPractitioners200Response(value: object): value is SearchPractitioners200Response {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function SearchPractitioners200ResponseFromJSON(json: any): SearchPractitioners200Response {
    return SearchPractitioners200ResponseFromJSONTyped(json, false);
}

export function SearchPractitioners200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchPractitioners200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': PractitionerSearchResponseFromJSON(json['data']),
    };
}

export function SearchPractitioners200ResponseToJSON(json: any): SearchPractitioners200Response {
    return SearchPractitioners200ResponseToJSONTyped(json, false);
}

export function SearchPractitioners200ResponseToJSONTyped(value?: SearchPractitioners200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': PractitionerSearchResponseToJSON(value['data']),
    };
}

